import React, { useState } from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { useColorModeValue } from '../../components/ui/color-mode';
import FitTabs from '../../components/shared/tabs/Tabs';
import { darkMode, lightMode } from '../../theme/config';
import ProfileTab from './ProfileTab';
import SecurityTab from './SecurityTab';

const SettingIndex = () => {
  const textColor = useColorModeValue(lightMode.textColor, darkMode.textColor);

  // Local state to manage active tab
  const [activeTab, setActiveTab] = useState('profile');

  // Define the two tabs we want to show
  const tabsData = [
    {
      label: 'Profile',
      value: 'profile',
      panel: <ProfileTab />
    },
    {
      label: 'Security',
      value: 'security',
      panel: <SecurityTab />
    },
    // You can later add 'Complaint Settings' and 'Notifications' here if needed
  ];

  const handleTabChange = (newTabValue) => {
    setActiveTab(newTabValue.value);
  };


  return (
    <Box p={6} color={textColor}>
      <Heading mb={4} size="3xl" fontWeight="bold" color={textColor}>Settings</Heading>
      <FitTabs
        value={activeTab}
        onChange={handleTabChange}
        tabs={tabsData}
        variant="enclosed"
      />
    </Box>
  );
};

export default SettingIndex;
